import React from 'react';
const bonuses = [{
  n: '1',
  img: 'https://cdn.magicpatterns.com/uploads/fiCtiavCWTyWecGemVYbRa/BONO_1_AROMAS.png',
  title: '120 Nombres Premium para tus Productos',
  desc: 'Deja de llamar a tus productos “Vela de Lavanda”. Descubre nombres que despiertan emociones y aumentan el valor percibido.',
  value: '$19 USD'
}, {
  n: '2',
  img: 'https://cdn.magicpatterns.com/uploads/f3vuXFciE2Tuvno2kdkmux/BONO_2_AROMAS.png',
  title: '24 Tarjetas de Ritual Imprimibles',
  desc: 'Convierte cada compra en una experiencia inolvidable con tarjetas listas para imprimir que enseñan a disfrutar cada producto.',
  value: '$19 USD'
}, {
  n: '3',
  img: 'https://cdn.magicpatterns.com/uploads/nW4EBZa3ekgotYsZzG5qKu/BONO_3_AROMAS.png',
  title: 'Checklist de Marca Premium',
  desc: 'Audita tu marca con una lista de 50 puntos y detecta en 15 minutos qué hace que tus productos parezcan comunes.',
  value: '$19 USD'
}, {
  n: '4',
  img: 'https://cdn.magicpatterns.com/uploads/3mru8FBmnYUhX5NsoUPZg4/BONO_4_AROMAS.png',
  title: 'Las 300 Palabras que Venden Aromas',
  desc: 'Escribe descripciones sensoriales que despierten emociones y hagan que tus clientes imaginen la experiencia antes de comprar.',
  value: '$19 USD'
}, {
  n: '5',
  img: 'https://cdn.magicpatterns.com/uploads/p5KYEYvt8dWGz998UmwVKT/BONO_5_AROMAS.png',
  title: 'Planner Anual de Colecciones Aromáticas',
  desc: 'Nunca vuelvas a preguntarte qué lanzar. Un calendario completo con ideas de colecciones, temporadas y campañas para todo el año.',
  value: '$19 USD'
}];
export function Bonuses() {
  return <section className="w-full bg-[#f7f3ec] px-5 py-14" data-id="element-50" data-mp="33h5nh63wvsti">
      <div className="mx-auto max-w-md" data-id="element-51" data-mp="33gdzohgk2zds">
        <div className="text-center" data-id="element-52" data-mp="nq1bz1drb6th">
          <span className="inline-flex items-center gap-2 rounded-full bg-[#7c6aa8]/10 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-[#7c6aa8]" data-id="element-53" data-mp="np004uox2gap">
            🎁 Bonos exclusivos de hoy
          </span>
          <h2 className="mt-4 font-serif-display text-3xl font-bold leading-tight text-[#3b3350]" data-id="element-54" data-mp="3ci4xjkez9vvi">
            Además, hoy también recibirás 5 bonos gratis
          </h2>
          <p className="mt-3 text-sm text-[#7a7288]" data-id="element-55" data-mp="3ljcsbsiaceku">
            Herramientas para implementar más rápido y aumentar el valor percibido desde el primer día.
          </p>
        </div>

        <div className="mt-8 space-y-5" data-id="element-56" data-mp="2tsoq0d4vl35l">
          {bonuses.map(b => <article key={b.n} className="overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-[#e4dbcc]" data-id="element-57" data-mp="2tqlu5ch1kfsy">
              <div className="aspect-square w-full bg-[#efe7da] p-3 sm:p-5" data-id="element-58" data-mp="32sbj8bngb2nk">
                <img src={b.img} alt={`Bono ${b.n}: ${b.title}`} className="h-full w-full object-contain" data-id="element-59" data-mp="37k3citxzrmhe" />
              </div>
              <div className="p-5" data-id="element-60" data-mp="2f30u5rfgqwp9">
                <div className="mb-2 flex items-center justify-between" data-id="element-61" data-mp="2f1y23g6emo7r">
                  <span className="rounded-full bg-[#7c6aa8] px-3 py-1 text-xs font-bold uppercase tracking-wide text-white" data-id="element-62" data-mp="27iyipaiy0woe">
                    Bono #{b.n}
                  </span>
                  <span className="text-sm font-bold text-[#6f9160]" data-id="element-63" data-mp="1xlalmdxv7d32">
                    Valor: {b.value}
                  </span>
                </div>
                <h3 className="font-serif-display text-lg font-semibold leading-snug text-[#3b3350]" data-id="element-64" data-mp="1tjyqxu04w1o0">
                  {b.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-[#5a5266]" data-id="element-65" data-mp="1ju5iv2z7a4oi">{b.desc}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}